import React from 'react'
import { IonButton, IonButtons, IonIcon, IonLabel } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import { closeCircleOutline } from 'ionicons/icons'

interface IReplacePatientProps {
  onClickAction: () => void
}

const ReplacePatientButton: React.FC<IReplacePatientProps> = (props: IReplacePatientProps) => {
  const { t } = useTranslation()
  const { onClickAction } = props

  const onReplacePatientClick = () => {
    onClickAction()
  }

  return (
    <IonButtons className='btn-grps ion-padding'>
      <IonButton
        data-testid='ReplacePatientButton'
        className='btn'
        fill='solid'
        color='danger'
        expand='block'
        onClick={onReplacePatientClick}>
        <IonIcon icon={closeCircleOutline} size='large'></IonIcon>
        <IonLabel>{t('patientDemographics.ReplacePatient')}</IonLabel>
      </IonButton>
    </IonButtons>
  )
}

export default ReplacePatientButton
